import pathConstant from "../../utils/path.constant";
import { useAuth } from "./authContext";
import { AuthContextState } from "../../utils/types";
import { useNavigate } from "react-router-dom";

export const useLogout = () =>{
    const navigate = useNavigate();
    const { logout } = useAuth() as AuthContextState;

    const handleLogout = ()=>{
        logout();
        localStorage.removeItem('lastProtectedRouted');
        navigate(pathConstant.LOGOUT);
    }

    return (handleLogout);
}